import { inject, Injectable } from '@angular/core';
import { MatomoTracker } from '@ngx-matomo/tracker';

enum EventTrackerCategories {
  LOGIN = 'log-in',
}

@Injectable({ providedIn: 'root' })
export class EventTrackerService {
  private matomoTracker = inject(MatomoTracker);

  trackLogin(customerName: string): void {
    this.matomoTracker.trackEvent(EventTrackerCategories.LOGIN, customerName);
  }
}
